{
  "es": {
    "whats_new": {
      "category": {
        "news": "Noticia",
        "product": "Actualización de producto",
        "tip": "Consejo"
      },
      "category_plural": {
        "news": "Noticias",
        "product": "Actualizaciones de producto",
        "tip": "Consejos"
      },
      "earlier": "Anteriores",
      "empty_description": "Las nuevas funciones, consejos y noticias de Ziggu aparecerán aquí.",
      "empty_title": "Aún no hay publicaciones",
      "helpful": "Útil",
      "helpful_impersonation": "No es posible durante una suplantación.",
      "helpful_mark": "Marcar como útil",
      "helpful_marked": "Te ha resultado útil",
      "image_open": "Abrir imagen {index} de {count}",
      "load_failed_description": "Comprueba tu conexión e inténtalo de nuevo.",
      "load_failed_title": "No se pudieron cargar las publicaciones",
      "new": "Nuevo",
      "no_matches_description": "Ninguna publicación coincide con tu búsqueda o tus filtros. Limpia los filtros para verlo todo.",
      "no_matches_title": "Sin resultados",
      "read_more": "Leer más",
      "retry": "Reintentar",
      "search": "Buscar publicaciones…",
      "subtitle": "Nuevas funciones, consejos y noticias del equipo de Ziggu.",
      "title": "Qué hay de nuevo"
    }
  }
}
